<template>
  <div @mouseenter="mouseenter" @mouseleave="mouseleave">
    <slot v-bind="{ selectSlide }"></slot>
  </div>
</template>
<script>
import Swiper from "swiper/bundle";
import $ from "cash-dom";

export default {
  data() {
    return {
      swiper: null
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.swiper = new Swiper(this.$el, {
        slidesPerView: "auto",
        //effect: "fade",
        hashNavigation: false,
        spaceBetween: 0,
        speed: 750,
        loop: true,
        autoplay: {
          delay: 60000
        },
        navigation: {
          nextEl: ".button-next",
          prevEl: ".button-prev"
        }
      });
    });
  },
  methods: {
    mouseenter() {
      if (this.swiper) {
        this.swiper.autoplay.stop();
      }
    },
    mouseleave() {
      if (this.swiper) {
        this.swiper.autoplay.start();
      }
    },
    selectSlide(event) {
      var index = $(event.target).index();

      if (this.swiper.activeIndex === index + 1) {
        this.swiper.slidePrev();
      } else if (this.swiper.activeIndex === index - 1) {
        this.swiper.slideNext();
      }
    }
  }
};
</script>

<style lang="scss">
.swiper-container {
  height: 100%;
}
</style>
